import { useState } from 'react';

export const useForceRerender = () => {
  const [, setValue] = useState(0);
  return () => setValue((value) => value + 1);
};
